import { Button, IconButton, TextField } from '@material-ui/core';
import { DragIndicator, Edit, RemoveCircleRounded } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useReducer } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';
import CustomTextField from '../../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../../../../utils/formUtils';
import { createRoomConfigs } from '../../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../../utils/NotificationUtils';
import { fetchGRERoomList, fetchGRETemplates } from '../../../../../configurationSlice';
import './Template-Rooms.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../../utils/loaderSlice';

const GuestRoomExperienceTemplateRooms = (props) => {
  const { toggleDrawer, template, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    roomFrom: {
      value: '',
      fieldName: 'Room From',
      errors: {},
      validations: ['required', 'positiveOnly'],
    },
    roomUpto: {
      value: '',
      fieldName: 'Room Upto',
      errors: {},
      validations: ['required', 'positiveOnly'],
    },
  });

  const [roomRange, setRoomRange] = useReducer((state, newState) => ({ ...state, ...newState }), {
    range: {
      value: [],
      fieldName: 'Room Range',
      errors: {},
      validations: [],
    },
  });

  useEffect(() => {
    const currRanges = [...template?.rangeList].map((item, index) => {
      return {
        index: index + 1,
        rangeFrom: item?.rangeFrom,
        rangeTo: item?.rangeTo,
      };
    });

    // Update List
    const roomRangeCopy = { ...roomRange.range };
    roomRangeCopy.value = currRanges;
    setRoomRange({ range: roomRangeCopy });
  }, [template]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const clearInputFields = () => {
    ['roomFrom', 'roomUpto'].forEach((item) => {
      let objCopy = { ...formData[item] };
      objCopy.value = '';
      setFormData({ [item]: objCopy });
    });
  };

  const onItemAdd = () => {
    if (validate()) {
      const roomRangeCopy = { ...roomRange.range };
      const currList = [...roomRangeCopy.value];
      const newObj = {
        index: currList.length + 1,
        rangeFrom: formData?.roomFrom?.value,
        rangeTo: formData?.roomUpto?.value,
      };
      currList.push(newObj);
      roomRangeCopy.value = currList;
      setRoomRange({ range: roomRangeCopy });
      clearInputFields();
    }
  };

  const onItemDelete = (index, listField) => {
    const currField = { ...roomRange[listField] };
    const list = currField.value;
    list.splice(index, 1);
    currField.value = list;
    setRoomRange({ [listField]: currField });
  };

  const onItemEdit = (index, listField) => {
    const selectedItem = roomRange.range.value?.find((item, i) => i === index);
    [
      { name: 'roomFrom', value: 'rangeFrom' },
      { name: 'roomUpto', value: 'rangeTo' },
    ].forEach((item) => {
      let objCopy = { ...formData[item.name] };
      objCopy.value = selectedItem[item.value];
      setFormData({ [item.name]: objCopy });
    });
    onItemDelete(index, listField);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const grid = 8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 6,
    margin: `0 0 ${grid}px 0`,
    color: '#828282',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FBFBFB',
    border: isDragging ? '2px solid #03E67C' : '2px solid #FBFBFB',
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? '#CFF8E0' : '#FFF',
    padding: grid,
    width: '100%',
  });

  const onDragEnd = (result, listField) => {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      roomRange[listField].value,
      result.source.index,
      result.destination.index,
    );
    const mainFormField = { ...formData[listField] };
    mainFormField.value = items;
    setRoomRange({ [listField]: mainFormField });
  };

  const refactorRoomRangeList = (roomRangeArr) => {
    return roomRangeArr.map((item) => {
      return {
        rangeFrom: parseInt(item.rangeFrom),
        rangeTo: parseInt(item.rangeTo),
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      if (hotelId && template?.id) {
        createRoomConfigs(hotelId, template?.id, refactorRoomRangeList(roomRange.range.value)).then(
          (res) => {
            dispatch(fetchGRETemplates(hotelId));
            dispatch(fetchGRERoomList(hotelId));
            onCancel();
            notificationManager('success', 'Room Configurations created successfully');
          },
        );
      }
    } catch (error) {
      if (error?.message) {
        notificationManager('danger', error?.message);
      } else {
        notificationManager('danger', 'Unable to create room configurations');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  return (
    <form onSubmit={handleSubmit} className='template-rooms' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{template && `Add Rooms to ${template.name}`}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-3'>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.roomFrom}
              handleInputChange={(e) => {
                setFormData({ roomFrom: e });
              }}
            />
          </div>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.roomUpto}
              handleInputChange={(e) => {
                setFormData({ roomUpto: e });
              }}
            />
          </div>
        </div>
        <div className='row d-flex w-100 px-3'>
          <div className='w-100 col-md-12 mb-3'>
            <Button
              variant='outlined'
              color='primary'
              onClick={() => {
                onItemAdd();
              }}
            >
              Add
            </Button>
          </div>
        </div>
        {/* Add Component Content */}
        <div className='col-md-12 mb-3 drag-item'>
          <DragDropContext onDragEnd={(e) => onDragEnd(e, 'range')}>
            <Droppable droppableId='droppable'>
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {roomRange?.range?.value.map((item, index) => (
                    <Draggable key={'' + item.index} draggableId={'' + item.index} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          className='list-item'
                        >
                          <DragIndicator className='list-item-drag col-2' />
                          <TextField
                            label='Range From'
                            id='range-from'
                            value={item.rangeFrom}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label='Range To'
                            id='range-to'
                            value={item.rangeTo}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <Edit
                            onClick={(e) => onItemEdit(index, 'range')}
                            className='list-item-remove'
                            color='secondary'
                          ></Edit>
                          <RemoveCircleRounded
                            onClick={(e) => onItemDelete(index, 'range')}
                            className='list-item-remove'
                            color='secondary'
                          ></RemoveCircleRounded>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        {/* End */}
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button variant='contained' type='submit' color='primary' className='me-3' size='large'>
              {template ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceTemplateRooms;
